import { WalletConfig } from './types'

export const CONFIG: WalletConfig = {
  API_BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    'https://server.palo-tea-connection-web-api.development.palo.mag.dev',
}
